import * as React from 'react'
import { useContextsStore } from '../../stores/useContextsStore'
import {
    isInIframe,
    isGraphOnlyMode,
    isHideAlways,
} from '../LeftMenuMigration/legacyBridge'
import AccessDeniedScreen from './AccessDeniedScreen'
import AccessDeniedCompact from './AccessDeniedCompact'

// Fixed, z-index-lifted overlay shared by both access-denied variants: the
// legacy shell (#wrapper) paints over the static #react-root, so an in-flow
// screen would render behind it, invisible. Shared so the two can't drift.
export const accessDeniedOverlaySx = {
    position: 'fixed',
    top: '50%',
    left: 0,
    width: '100%',
    transform: 'translateY(-50%)',
    zIndex: theme => theme.zIndex.drawer - 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}

// For the access-denied surface specifically we DO treat any iframe as embed:
// a third-party page wrapping our URL doesn't want a full-page login CTA.
// `legacyBridge.isInIframe()` notes iframe isn't an automatic embed signal
// for the main UI; that distinction matters for chrome visibility, not here.
function isEmbedView() {
    return isInIframe() || isGraphOnlyMode() || isHideAlways()
}

export default function AccessGate({ children }) {
    const accessDenied = useContextsStore(state => state.accessDenied)
    const loaded = useContextsStore(state => state.loadedContextList)

    if (loaded && accessDenied) {
        return isEmbedView() ? (
            <AccessDeniedCompact reason={accessDenied.reason} />
        ) : (
            <AccessDeniedScreen reason={accessDenied.reason} />
        )
    }
    return children
}
